<template>
  <Modal
    @close="setCloseModal"
    :show="showModal">
    <h1 slot="header">{{ $t('vue2.createusers.create_users') }}</h1>
    <div slot="body" class="cu">
      <div class="cu-tab-content">
        <createUserForm
          :country="country"
          :pushname="pushNameFromSelect2"
          @editedUsers="setUsers"
          @onNameInput="checkForDoubleNames">
        </createUserForm>
        <SearchForCalendar v-if="isTestSchool" :query="activeInputName" calendarType="users"
                           style="border-top: 1rem solid #edf0f5"></SearchForCalendar>
      </div>
    </div>
    <div>
    </div>
    <div slot="footer"
         class="flex flex-end pad-10">
      <!-- Inactive button -->
      <button v-if="showInactiveButton"
              class="create-form__submit">
        {{ $t('vue2.createusers.create') }}
      </button>
      <!-- Normal Create Button -->
      <button v-if="usersToSubmit.length > 0"
              class="submit-button"
              @click="submitUsers">
        {{ buttonText }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'
import createUserForm from './CreateUsersForm'
import SearchForCalendar from '../../Students/SearchForCalendar'

export default {
  components: {Modal, createUserForm, SearchForCalendar},
  computed: {
    showInactiveButton () {
      if (this.usersToSubmit.length < 1) {
        return true
      }
    },
    openFromOtherComponent () {
      return eventbus.createUserModal
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    isTestSchool () {
      return window.SCHOOL.id === 7272 || window.SCHOOL.id === 9111 || window.SCHOOL.id === 3
    },
    country () {
      return this.$store.state.activeSchool.country
    },
    usersToSubmit () {
      let usersToSubmit = []
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].name.length > 0) {
          let userobj = {
            name: this.users[i].name
          }
          if (this.users[i].unilogin.length > 0) {
            userobj.unilogin = this.users[i].unilogin
          }
          if (this.users[i].feide.length > 0) {
            userobj.feide = this.users[i].feide
          }
          if (this.users[i].email.length > 0) {
            userobj.email = this.users[i].email
          }
          usersToSubmit.push(userobj)
        }
      }
      return usersToSubmit
    },
    buttonText () {
      if (this.usersToSubmit.length < 1) {
        return this.$t('vue2.createusers.create')
      }
      let users = this.usersToSubmit.length === 1 ? this.$t('vue2.createusers.user') : this.$t('vue2.createusers.users')
      return this.$t('vue2.createusers.create') + ' ' + this.usersToSubmit.length + ' ' + users
    }
  },
  data () {
    return {
      showModal: false,
      users: [],
      pushNameFromSelect2: '',
      openedFromRoRSelect2: false,
      activeInputName: ''
    }
  },
  watch: {
    openFromOtherComponent () {
      if (this.openFromOtherComponent) {
        this.setShowModal()
      }
    }
  },
  methods: {
    checkForDoubleNames (name) {
      this.activeInputName = name
    },
    setUsers (users) {
      this.users = users
    },
    validateEmail (user, email) {
      if (email.length < 1) {
        this.users[this.users.indexOf(user)].validEmail = true
      } else {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.users[this.users.indexOf(user)].validEmail = re.test(String(email).toLowerCase())
      }
    },
    setShowModal () {
      this.showModal = true
    },
    setCloseModal () {
      this.showModal = false
      eventbus.createUserModal = false
      this.users = []
      this.openedFromRoRSelect2 = false
    },
    submitUsers () {
      let isOpenedFromRoRSelect2 = false
      // Check this.openedFromRoRSelect2 before this.setCloseModal()
      if (this.openedFromRoRSelect2) {
        isOpenedFromRoRSelect2 = true
      }
      let successText = this.usersToSubmit.length > 1 ? this.$t('vue2.createusers.users_created') : this.$t('vue2.createusers.user_created')
      docendo.schoolUsersCreate(
        this.activeSchool.id,
        this.usersToSubmit,
        success => {
          eventbus.toast = {text: successText, 'success': true}
          this.$store.dispatch('getSchoolCalendars', this.activeSchool.id)
          this.$store.dispatch('updateUserSettings', {'setup_widget_progress_users': true})
          this.$store.dispatch('getUsers', this.activeSchool.id)
          if (window.Intercom) {
            window.Intercom('trackEvent', 'Created Users')
          }
          eventbus.createdId = success[0].id
          if (isOpenedFromRoRSelect2) {
            this.$helpers.sendCustomEvt('vue_created_user', success[0].id)
          }
          if (eventbus.createUserModalROR) {
            window.location.reload()
          }
          // activate onboardArrow again
          setTimeout(() => {
            this.$store.commit('setOnboardingStep', 0)
          }, 2500)
        }, errors => {
          eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
        })
      this.setCloseModal()
    }
  },
  mounted () {
    // Can also be opened from ROR select2-button
    window.addEventListener('vueCreateUser', e => {
      this.openedFromRoRSelect2 = true
      this.pushNameFromSelect2 = e.detail === null ? '' : e.detail
      eventbus.createUserModal = true
    }, false)
  }
}
</script>

<style scoped>
@import '../../../assets/css/variables.css';

.cu-tab-content {
  margin: -10px -20px;
  padding-top: 20px;
  background: white;
}

.modal-form-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 30px;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #999
}

.modal-form__titles {
  padding: 0 30px;
  margin-bottom: 10px;
}

.modal-form__titles > h3:nth-child(2) {
  padding-right: 20px;
}

.flex-1 {
  flex: 1;
}

.create-form {
  width: 98%;
  margin-top: 10px;
}

.modal-form-group > .delete__user {
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.modal-form-group > .delete__user:hover {
  background-color: #ffdcdc;
  border: 1px solid #d72b3f;
  color: #d72b3f;
}

.create-form:first-child {
  margin-top: 0;
}

.create-form:last-child {
  border-bottom: 0 !important;
}

.create-form > div {
  flex: 1;
}

.create-form > div:first-child,
.flex-1:first-child {
  margin-right: 5px;
}

.create-form > div:nth-child(2) {
  margin-left: 5px;
}

.create-form > div label {
  font-size: 10px;
}

.flex-end {
  justify-content: flex-end;
}

.add-more-button {
  padding: 10px 30px;
  color: var(--blue);
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
}

.add-more-button:hover .add-more-button__text {
  text-decoration: underline;
}

.plus--icon {
  cursor: pointer;
  display: inline-flex;
  border: 2px solid var(--blue);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: space-around;
  font-weight: bold;
  font-size: 15px;
  padding-left: 1px;
  text-decoration: none !important;
}

.create-form__submit {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f6f7f8 !important;
  border: 1px solid #d8d8d8 !important;
}

.inputError {
  border-color: #d72b3f;
}

.error-text {
  font-size: 11px;
  color: #d72b3f;
}
</style>



// WEBPACK FOOTER //
// CreateUser.vue?2e2c6c46